import React from 'react'
import { DocLink } from './doc-link'
import type { Blog } from '@ztechapps/common.contract'

export const DocTitleLink = ({ post }: { post: Blog }) => {
  return (
    <li>
      <DocLink slug={post.slug}>{post.title}</DocLink>
    </li>
  )
}
